import React from 'react';
import { Box, Typography } from '@mui/material';
import AdminQuestionManager from '../../admin/QuestionManager';

/**
 * Question Manager component for managers
 * This is a wrapper around the admin QuestionManager component
 * but placed within the audit section for managers
 */
const ManagerQuestionManager = () => {
  return (
    <Box sx={{ p: 3 }}>
      {/* <Typography variant="h4" gutterBottom>
        Question Management
      </Typography>
      <Typography variant="body1" paragraph>
        Create and manage questions that can be used in questionnaires.
      </Typography>
       */}
      {/* Use the existing QuestionManager component */}
      <AdminQuestionManager />
    </Box>
  );
};

export default ManagerQuestionManager;
